import React from "react";

const VisaBrand = ({fill}) => (
  <svg
    width="44"
    height="25"
    viewBox="0 0 44 25"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M40.7403 19.7835L40.3278 17.6089H35.7188L34.9855 19.768L31.2913 19.7758C33.6661 13.759 35.4286 9.30219 36.5787 6.40528C36.8793 5.64755 37.4128 5.26095 38.1993 5.26675C38.8007 5.27191 39.7821 5.27255 41.1437 5.26869L44 19.7777L40.7403 19.7835ZM36.7547 14.6302H39.7265L38.6173 9.17912L36.7547 14.6302ZM12.947 5.26482L16.6613 5.26869L10.9193 19.7854L7.15917 19.7816C6.21362 15.9471 5.27984 12.1095 4.35783 8.26869C4.1745 7.50322 3.8115 6.96778 3.113 6.71456C2.48844 6.48905 1.45078 6.14046 0 5.66881V5.26869H5.9345C6.96117 5.26869 7.56067 5.79253 7.75317 6.86727C7.9475 7.94459 8.43639 10.6856 9.21983 15.0902L12.947 5.26482ZM21.7653 5.26869L18.8302 19.7835L15.2937 19.7777L18.2233 5.26482L21.7653 5.26869ZM28.9337 5C29.9915 5 31.3243 5.34794 32.0907 5.66881L31.471 8.67655C30.778 8.38273 29.6377 7.98647 28.6788 8C27.2855 8.02513 26.4238 8.64175 26.4238 9.23325C26.4238 10.1959 27.9198 10.6811 29.4598 11.7326C31.2162 12.9311 31.449 14.0077 31.427 15.1791C31.4032 17.605 29.4598 20 25.3605 20C23.4905 19.971 22.8158 19.8067 21.2905 19.2345L21.9358 16.0954C23.4887 16.7796 24.1468 16.9981 25.4742 16.9981C26.6897 16.9981 27.7328 16.48 27.742 15.5773C27.7493 14.9356 27.3753 14.6166 26.0113 13.8241C24.6473 13.0316 22.7333 11.9317 22.759 9.72229C22.7902 6.89626 25.3293 5 28.9337 5Z"
      fill={fill}
    />
  </svg>
);

export default VisaBrand;
